import React, { Component } from 'react'
import { Row, Col, Button, Modal, Table } from 'antd'
import { api, app, config } from "../../app"
import utils from "../../utils"

class DonationMy extends Component {
    constructor (props) {
        super(props)
        this.state = {
            dataList: [],
            images: [],
            page: 1,
            total: 0,
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.handleData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    handleData = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let params = {
            page,
            query_status: '1',
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, { flag, data, msg, total } = await app.post(api.DonateLists, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            this.setData({
                dataList: utils.addArrayKey(data),
                data_loading: false,
                total: parseInt(total || 0),
            })
        }
    }

    /**
     * 图片预览
     * @param item
     */
    handleRead = (item) => {
        Modal.info({
            title: '捐赠阅览',
            destroyOnClose: true,
            centered: true,
            okText: "确定",
            width: 600,
            content: (
                <div>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠类型</Col>
                        <Col span={18}>{item.donate_type === '1' ? '内部捐赠' : '外部捐赠'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠物品名称</Col>
                        <Col span={18}>{item.goods_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠人姓名</Col>
                        <Col span={18}>{item.donate_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠人联系方式</Col>
                        <Col span={18}>{item.mobile}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠对象类型</Col>
                        <Col span={18}>{item.donate_object_type === '1' ? '队伍' : '个人'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠对象</Col>
                        <Col span={18}>{item.donate_object.object_name}({item.donate_object.object_numbering})</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠数量</Col>
                        <Col span={18}>{item.number}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>审核人</Col>
                        <Col span={18}>{item.admin_name || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>审核状态</Col>
                        <Col
                            span={18}>{item.admin_audit === '0' ? '未审核' : (item.admin_audit === '1' ? '已通过' : '不通过')}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>审核时间</Col>
                        <Col span={18}>{item.admin_time || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠时间</Col>
                        <Col span={18}>{item.donate_time}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>提交时间</Col>
                        <Col span={18}>{item.add_time}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>签收人</Col>
                        <Col span={18}>{item.sign_name || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>签收状态</Col>
                        <Col span={18}>{item.is_sign === '1' ? '已签收' : '未签收'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>签收时间</Col>
                        <Col span={18}>{item.sign_time || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>捐赠原因</Col>
                        <Col span={18}>{item.donate_reason || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>物品说明</Col>
                        <Col span={18}>{item.describe || '-'}</Col>
                    </Row>
                    <Row>
                        <Col span={6}>物品图片</Col>
                        <Col span={18}>{item.images.map((img, i) => {
                            return <div style={{ height: 200, textAlign: "center" }}>
                                <img style={{ width: "auto", height: "auto", maxHeight: "100%", maxWidth: "100%" }}
                                     src={config.imgUrl + img} key={i} alt=""/>
                            </div>
                        })}</Col>
                    </Row>
                </div>
            ),
        })
    }

    render () {
        let { dataList, page, total, data_loading } = this.state,
            columns = [
                {
                    title: '捐赠物品',
                    dataIndex: 'goods_name',
                    key: 'goods_name',
                    width: '15%'
                },
                {
                    title: '捐赠对象',
                    dataIndex: 'donate_object',
                    key: 'donate_object',
                    width: '15%',
                    render ({ object_name, object_numbering }) {
                        return (<span>
                                    <div>{object_name}</div>
                                    <div>({object_numbering})</div>
                                </span>)
                    }
                },
                {
                    title: '捐赠阅览',
                    dataIndex: 'work_before',
                    key: 'work_before',
                    width: '10%',
                    render: (donate_reason, item) => {
                        return <div style={{ color: '#3399CC', cursor: 'pointer' }}
                                    onClick={() => this.handleRead(item)}>捐赠阅览</div>
                    }
                },
                {
                    title: '捐赠数量',
                    dataIndex: 'number',
                    key: 'number',
                    width: '10%'
                },
                {
                    title: '捐赠时间',
                    dataIndex: 'donate_time',
                    key: 'donate_time',
                    width: '15%'
                },
                {
                    title: '审核状态',
                    dataIndex: 'admin_audit',
                    key: 'admin_audit',
                    width: '10%',
                    render (audit) {
                        if (audit === '0') {
                            return '未审核'
                        } else if (audit === '1') {
                            return '已通过'
                        } else {
                            return '不通过'
                        }
                    }
                },
                {
                    title: '签收状态',
                    dataIndex: 'is_sign',
                    key: 'is_sign',
                    width: '10%',
                    render (is_sign) {
                        return is_sign === '1' ? '已签收' : '未签收'
                    }
                },
                {
                    title: '捐赠人',
                    dataIndex: 'donate_name',
                    key: 'donate_name',
                    width: '15%'
                },
            ]
        return (
            <div className="donation">
                <h1 className="donation-title">我的捐赠</h1>
                <div className="donation-content">
                    <Table columns={columns}
                           locale={app.tbLocale(data_loading)}
                           dataSource={dataList}
                           loading={data_loading}
                           scroll={{ y: 'calc(100% - 38px)' }}
                           className="donation_table2"
                           pagination={{
                               total,
                               pageSize: 20,
                               current: page,
                               showTotal: (total) => `总数量：${total}`,
                               onChange: this.handleData
                           }}
                           size="small"
                    />
                </div>
            </div>
        )
    }
}

export default DonationMy



// WEBPACK FOOTER //
// ./src/routes/donation/DonationMy.jsx